package br.com.vvrefeicoes.portal.domain.model

/** Cartões do topo da tela RMP: contam todos os RMPs que o usuário enxerga, sem a busca nem os filtros. */
data class RmpOverviewSummary(
    val total: Long = 0,
    val finished: Long = 0,
    val inProgress: Long = 0,
    val myPending: Long = 0,
)

/** Uma linha da tela RMP; `code` é o ID exibido (o portal continua a contagem dos ids do RMP antigo). */
data class RmpOverviewItem(
    val id: String,
    val source: String,
    val code: String,
    val type: String?,
    val typeLabel: String?,
    val status: String?,
    val statusLabel: String?,
    val requesterName: String?,
    val requesterEmail: String?,
    val unitName: String?,
    val waitingStageLabel: String?,
    val waitingName: String?,
    val myPending: Boolean,
    val createdAt: String?,
    val updatedAt: String?,
    /** Quem fez a última ação (aprovou, rejeitou ou concluiu) e em qual etapa. */
    val actorName: String? = null,
    val actorStageLabel: String? = null,
    /** Cargo (ou setor) de quem solicitou, mostrado embaixo do nome. */
    val requesterRole: String? = null,
    /** O que precisa ser feito na etapa atual ("Ações necessárias"); null quando não aguarda ninguém. */
    val requiredAction: String? = null,
) {
    /** Aberto no portal: tem fluxo de aprovação no portal; os demais vêm do sistema antigo. */
    val isPortal: Boolean get() = source == "PORTAL"
}

/** Abas da tela RMP (mesmos nomes da API). */
enum class RmpOverviewView {
    /** RMPs em andamento das unidades do usuário: onde se aprova ou rejeita. */
    ANDAMENTO,

    /** Concluídos das unidades do usuário no organograma vigente, inclusive os anteriores a ele. */
    UNIDADE,

    /** RMPs em que o usuário decidiu alguma etapa, mesmo depois de sair da unidade. */
    USUARIO,
}

data class RmpOverview(
    val summary: RmpOverviewSummary,
    val items: List<RmpOverviewItem>,
    val totalPages: Int,
    val totalElements: Long,
    /** Fluxo nativo do RMP ligado na API: só então a tela oferece o "Solicitar RMP". */
    val requestsEnabled: Boolean = false,
    /** Totais por status e tipo da lista filtrada e as opções dos filtros. */
    val totals: RmpOverviewTotals = RmpOverviewTotals(),
)

/** Total de RMPs de um valor (tipo, status ou etapa): [key] para filtrar e o rótulo. */
data class RmpOverviewCount(
    val key: String,
    val label: String,
    val total: Long,
)

/** Totais da lista filtrada (dashboard) e as opções dos filtros (tipos, unidades e etapas da aba). */
data class RmpOverviewTotals(
    val byStatus: List<RmpOverviewCount> = emptyList(),
    val byType: List<RmpOverviewCount> = emptyList(),
    val types: List<RmpOverviewCount> = emptyList(),
    val units: List<String> = emptyList(),
    val stages: List<RmpOverviewCount> = emptyList(),
)

/** Filtros da tela RMP além da busca: tipo, unidade, período de criação (aaaa-mm-dd) e etapa. Null não filtra. */
data class RmpOverviewFilters(
    val type: String? = null,
    val unit: String? = null,
    val from: String? = null,
    val to: String? = null,
    val stage: String? = null,
) {
    val active: Boolean
        get() = listOfNotNull(type, unit, from, to, stage).isNotEmpty()
}

/** Relatórios em planilha (mesmas colunas do sistema antigo). */
enum class RmpReportKind {
    GERAL,
    ALTERACAO,
    TRANSFERENCIA,
    ADMISSAO,
}
